import styled from 'styled-components';

const StepMLStyled = styled.div`
  .step-form-wrap {
    font-family: SourceHanSansCN;
    .text-input-style {
      width: 100%;
    }
    .MuiTypography-colorTextSecondary {
      color: #000000;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: ${(props) => props.theme.palette.primary.main};
    }
    .input-error-style {
      color: #f44336;
      margin: 0;
      font-size: 0.75rem;
      margin-top: 3px;
      text-align: left;
      font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
      font-weight: 400;
      line-height: 1.66;
      margin-left: 14px;
      letter-spacing: 0.03333em;
    }
    .select-wrap-style {
      width: 100%;
    }
    .textField-area-wrap {
      textarea {
        padding-top: 10px;
      }
    }
    .init-error-style {
      color: #f44336;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1.66;
      letter-spacing: 0.03333em;
      text-align: left;
      margin-top: 3px;
      margin-right: 0;
      margin-bottom: 0;
      margin-left: 0;
      margin-left: 14px;
    }
    .stores-setting-button {
      width: 90px;
    }
    .init-tabs-wrap-style {
      .init-tab-style-one {
        border-left: 1px solid #818286;
        border-top-left-radius: 3px;
      }
      .init-tab-style-four {
        border-right: 1px solid #818286;
        border-top-right-radius: 3px;
      }
      .init-tab-style {
        color: #666464;
        font-size: 16px;
        background-color: #ffffff;
        border-top: 1px solid #818286;
      }
      .Mui-selected {
        color: #ffffff;
        background-color: ${(props) => props.theme.palette.primary.main};
        border: 0;
      }
    }
    .init-tabs-wrap > .MuiBox-root {
      padding: 0;
    }
  }
`;
export default StepMLStyled;
